import { render, staticRenderFns } from "./digikalaOrderItemsList.vue?vue&type=template&id=5f49e8e1&scoped=true&"
import script from "./digikalaOrderItemsList.vue?vue&type=script&lang=js&"
export * from "./digikalaOrderItemsList.vue?vue&type=script&lang=js&"
import style0 from "./digikalaOrderItemsList.vue?vue&type=style&index=0&id=5f49e8e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49e8e1",
  null
  
)

export default component.exports